<template>
  <div class="split-screen">
    <div class="left-panel">
      <div class="lp-bg-glow lp-glow-tr"></div>
      <div class="lp-bg-glow lp-glow-bl"></div>
      <div class="lp-grid"></div>
      <div class="lp-ring lp-ring-1"></div>
      <div class="lp-ring lp-ring-2"></div>
      <div class="lp-dot lp-dot-1"></div>
      <div class="lp-dot lp-dot-2"></div>
      <div class="lp-dot lp-dot-3"></div>

      <div class="lp-content pb-2">
        <h1 class="lp-title">{{$t("navigations.clinical trial monitoring")}} <br class="d-none d-lg-inline"/>{{$t("navigations.portal")}}</h1>
        <p class="lp-subtitle">{{$t("navigations.access secure patient data")}} &amp; {{$t("navigations.analytics")}}</p>
        <div class="lp-divider"></div>

        <div class="lp-features d-none d-md-flex">
          <div class="lp-feature-row">
            <div class="lp-feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0cb8a8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
              </svg>
            </div>
            <div>
              <div class="lp-feature-title">{{$t("navigations.real-time insights")}}</div>
              <div class="lp-feature-desc">{{$t("navigations.live patient data and analytics dashboard")}}</div>
            </div>
          </div>

          <div class="lp-feature-row">
            <div class="lp-feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0cb8a8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div>
            <div>
              <div class="lp-feature-title">{{$t("navigations.secure")}} &amp; {{$t("navigations.confidential")}}</div>
              <div class="lp-feature-desc">{{$t("navigations.end-to-end encrypted clinical data access")}}</div>
            </div>
          </div>

          <div class="lp-feature-row">
            <div class="lp-feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0cb8a8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <ellipse cx="12" cy="5" rx="9" ry="3"/>
                <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
                <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
              </svg>
            </div>
            <div>
              <div class="lp-feature-title">{{$t("navigations.intelligent data platform")}}</div>
              <div class="lp-feature-desc">{{$t("navigations.unified study")}} &amp; {{$t("navigations.traceability management")}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="right-panel">
      <div class="login-card">
        <div class="rp-logo">
          <img src="../../assets/img/IDS_Logo.png" alt="IDS Logo" />
        </div>

        <div class="rp-header">
          <h2 class="rp-title pt-3">{{$t("navigations.admin login")}}</h2>
          <div class="rp-accent-bar"></div>
          <p class="rp-subtitle">{{$t("navigations.sign in to access the dashboard")}}</p>
        </div>

        <div class="login-body">
          <form role="form" autocomplete="on" @submit.prevent="login">

            <div class="form-field">
              <label class="field-label" for="username">{{$t("navigations.emailaddress")}}</label>
              <div class="input-wrapper">
                
                <span class="field-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                </span>
      
                <input
                  id="username"
                  type="email"
                  class="field-input has-icon"
                  v-model="username"
                  placeholder="Enter your email"
                  required
                />
              </div>
            </div>

            <div class="form-field">
              <label class="field-label" for="password">{{$t("navigations.password")}}</label>
              <div class="input-wrapper">
                <span class="field-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                </span>
                <input
                  id="password"
                  :type="inputType"
                  class="field-input has-icon"
                  v-model="password"
                  placeholder="Enter your password"
                  required
                />
                <button
                  type="button"
                  class="toggle-visibility"
                  @click.prevent="passwordVisible()"
                  :aria-label="visibleOn ? 'Hide password' : 'Show password'"
                >
                  <svg v-if="!visibleOn" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                  <svg v-else  
                     viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div class="form-extras">
              <label class="remember-me">
                <input type="checkbox" v-model="rememberMe" />
                <span class="checkmark"></span>
                <span class="remember-label">{{ $t("navigations.remember me") }}</span>
              </label>
              <a href="#" class="forgot-link" @click.prevent="forgotPassword">{{ $t("navigations.forgot password?") }}</a>
            </div>

            <button type="submit" class="sign-in-btn" :disabled="loadingBlock">
              <span class="btn-spinner" v-if="loadingBlock" aria-label="Signing in"></span>
              <span v-else>
                <i class="fa fa-user"></i>
                {{ $t("navigations.login") }}</span>
            </button>

            <div v-if="errorBlock" class="error-message">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              <span>{{ errr }}</span>
            </div>

          </form>
        </div>

        <p class="rp-footer">{{ $t("navigations.secure system by ids intelligent data solutions") }}</p>
      </div>
    </div>

  </div>
</template>

<script src="./loginComponent.js"></script>

<style>
@import 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css';
@import '../../assets/css/style.css';

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

/* Allow scrolling on mobile, lock on desktop */
@media (max-width: 767.98px) {
  html, body {
    overflow-y: auto;
    overflow-x: hidden;
  }
}
@media (min-width: 768px) {
  html, body {
    overflow: hidden;
  }
}
</style>

<style scoped>
*, ::after, ::before { box-sizing: border-box; }

@media (prefers-reduced-motion: reduce) {
  *, ::after, ::before {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
  }
}
.split-screen {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  background: #0a0f1a;
}
.left-panel {
  flex: 0 0 58%;
  background: #060e17;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.75rem 2.5rem;
}

/* Glows */
.lp-bg-glow {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  animation: glowBreathe 6s ease-in-out infinite;
}
.lp-glow-tr {
  top: -100px; right: -100px;
  width: 350px; height: 350px;
  background: radial-gradient(ellipse, rgba(12,184,168,0.28) 0%, transparent 65%);
}
.lp-glow-bl {
  bottom: -80px; left: -80px;
  width: 300px; height: 300px;
  background: radial-gradient(ellipse, rgba(12,184,168,0.14) 0%, transparent 65%);
  animation-delay: 1.5s;
}
@keyframes glowBreathe {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.7; transform: scale(1.08); }
}

/* Grid overlay */
.lp-grid {
  position: absolute;
  inset: 0;
  background-image:
  linear-gradient(rgba(12,184,168,0.045) 1px, transparent 1px),
  linear-gradient(90deg, rgba(12,184,168,0.045) 1px, transparent 1px);
  background-size: 44px 44px;
  pointer-events: none;
}

/* Rings */
.lp-ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(12,184,168,0.12);
  pointer-events: none;
}
.lp-ring-1 {
  top: -50px; right: -50px;
  width: 220px; height: 220px;
  animation: ringSpin 34s linear infinite;
}
.lp-ring-2 {
  top: -15px; right: -15px;
  width: 130px; height: 130px;
  border-color: rgba(12,184,168,0.07);
  animation: ringSpinReverse 22s linear infinite;
}
@keyframes ringSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@keyframes ringSpinReverse {
  from { transform: rotate(0deg); }
  to { transform: rotate(-360deg); }
}

/* Dots */
.lp-dot {
  position: absolute;
  border-radius: 50%;
  background: #0cb8a8;
  pointer-events: auto;
  transition: transform 200ms ease, box-shadow 200ms ease;
}
.lp-dot-1 {
  top: 20%; right: 10%;
  width: 5px; height: 5px;
  opacity: 0.7;
  animation: floatDot1 7s ease-in-out infinite;
}
.lp-dot-2 {
  top: 65%; left: 9%;
  width: 3px; height: 3px;
  opacity: 0.5;
  animation: floatDot2 9s ease-in-out infinite;
  animation-delay: 0.6s;
}
.lp-dot-3 {
  bottom: 28%; right: 16%;
  width: 4px; height: 4px;
  opacity: 0.35;
  animation: floatDot3 8s ease-in-out infinite;
  animation-delay: 1.4s;
}
.lp-dot:hover {
  transform: scale(2.4);
  box-shadow: 0 0 14px rgba(12,184,168,0.8);
}
@keyframes floatDot1 {
  0%, 100% { transform: translate(0, 0); }
  25%      { transform: translate(14px, -10px); }
  50%      { transform: translate(4px, 10px); }
  75%      { transform: translate(-10px, -4px); }
}
@keyframes floatDot2 {
  0%, 100% { transform: translate(0, 0); }
  33%      { transform: translate(-10px, 12px); }
  66%      { transform: translate(12px, 6px); }
}
@keyframes floatDot3 {
  0%, 100% { transform: translate(0, 0); }
  50%      { transform: translate(-16px, -14px); }
}

.lp-content {
  position: relative;
  z-index: 1;
  text-align: center;
  width: 100%;
  max-width: 340px;
}

@keyframes fadeInUpCustom {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Heading */
.lp-title {
  color: #ffffff;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  line-height: 1.35;
  overflow: hidden;
  white-space: nowrap;
  opacity: 0;
  animation: typingReveal 1.2s steps(40) 0.3s forwards;
  width: 0;
}

@keyframes typingReveal {
  0% {
    opacity: 1;
    width: 0;
  }
  100% {
    opacity: 1;
    width: 100%;
  }
}
.lp-subtitle {
  color: rgba(255,255,255,0.35);
  font-size: 12px;
  margin: 0 0 1rem;
  opacity: 0;
  animation: fadeInUpCustom 0.6s ease-out 0.25s both;
}
.lp-divider {
  width: 38px;
  height: 2.5px;
  background: #0cb8a8;
  border-radius: 2px;
  margin: 0 auto 1.25rem;
  opacity: 0;
  animation: fadeInUpCustom 0.5s ease-out 0.32s both, dividerGrow 2.6s ease-in-out 1s infinite;
}
@keyframes dividerGrow {
  0%, 100% { width: 38px; }
  50%      { width: 54px; }
}

/* Feature rows */
.lp-features { display: flex; flex-direction: column; gap: 8px; text-align: left; }
.lp-feature-row {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255,255,255,0.025);
  border: 1px solid rgba(255,255,255,0.055);
  border-radius: 11px;
  padding: 11px 14px;
  transition: border-color 150ms, background 150ms, transform 150ms;
  cursor: default;
  opacity: 0;
  animation: fadeInUpCustom 0.5s ease-out both;
}
.lp-feature-row:nth-child(1) { animation-delay: 0.4s; }
.lp-feature-row:nth-child(2) { animation-delay: 0.52s; }
.lp-feature-row:nth-child(3) { animation-delay: 0.64s; }
.lp-feature-row:hover {
  border-color: rgba(12,184,168,0.35);
  background: rgba(12,184,168,0.05);
  transform: translateX(3px);
}
.lp-feature-icon {
  width: 36px; height: 36px;
  border-radius: 9px;
  background: rgba(12,184,168,0.12);
  border: 1px solid rgba(12,184,168,0.22);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 200ms ease, background 200ms ease;
}
.lp-feature-row:hover .lp-feature-icon {
  transform: scale(1.1) rotate(-4deg);
  background: rgba(12,184,168,0.2);
}
.lp-feature-icon svg { width: 17px; height: 17px; }
.lp-feature-title {
  color: rgba(255,255,255,0.88);
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 2px;
}
.lp-feature-desc {
  color: rgba(255,255,255,0.3);
  font-size: 10px;
  line-height: 1.5;
}

/* Footer */
.lp-footer {
  position: absolute;
  bottom: 1rem;
  z-index: 1;
  color: rgba(255,255,255,0.13);
  font-size: 9px;
  letter-spacing: 0.5px;
  text-align: center;
  margin: 0;
}
.right-panel {
  flex: 0 0 42%;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 2rem;
  overflow: hidden;
  border-left: 1px solid rgba(12,184,168,0.12);
}

.login-card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 20px;
  padding: 1.75rem 2.25rem 1.5rem;
  box-shadow: 0 8px 40px rgba(0,0,0,0.08), 0 0 0 1px rgba(12,184,168,0.07);
  opacity: 0;
  animation: cardEnter 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
  transition: box-shadow 250ms ease;
}
.login-card:hover {
  box-shadow: 0 10px 48px rgba(0,0,0,0.1), 0 0 0 1px rgba(12,184,168,0.12);
}
@keyframes cardEnter {
  from { opacity: 0; transform: translateY(26px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

/* Logo inside card */
.rp-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}
.rp-logo img {
  width: 100%;
  max-width: 160px;
  height: auto;
  object-fit: contain;
}

/* Card header */
.rp-header { margin-bottom: 1.25rem; }

.rp-accent-bar {
  width: 32px;
  height: 3px;
  background: linear-gradient(90deg, #0cb8a8, #7ffff4, #0cb8a8);
  background-size: 200% 100%;
  border-radius: 2px;
  margin-bottom: 0.6rem;
  animation: accentShimmer 2s ease-in-out 0.6s infinite,
             accentWidth   2.6s ease-in-out 0.6s infinite;
}

@keyframes accentShimmer {
  0%   { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

@keyframes accentWidth {
  0%, 100% { width: 32px; }
  50%       { width: 46px; }
}
/* .rp-accent-bar {
  background: linear-gradient(90deg, #0cb8a8, #7ffff4, #0cb8a8);
  background-size: 200% 100%;
  animation: accentPulse 2s ease-in-out 0.6s infinite;
} */

/* Change `infinite` to `1` in the animation shorthand */
.login-card:hover .rp-accent-bar {
  animation-play-state: paused;
  width: 58px;
  box-shadow: 0 0 10px rgba(12,184,168,0.5);
  transition: width 350ms ease, box-shadow 350ms ease;
}
@keyframes accentPulse {
  0%, 100% { width: 32px; opacity: 1; }
  50%      { width: 46px; opacity: 0.7; }
}

.rp-title {
  font-size: 20px;
  font-weight: 700;
  color: #0a0f1a;
  margin: 0 0 4px;
}
.rp-subtitle {
  font-size: 12.5px;
  color: #94a3ab;
  margin: 0;
}
.form-field { margin-bottom: 14px; }
.field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #4a5568;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.input-wrapper { position: relative; }

.field-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  color: #a0aec0;
  pointer-events: none;
  transition: color 180ms ease, transform 180ms ease;
}
.field-icon svg { width: 17px; height: 17px; }
.input-wrapper:focus-within .field-icon {
  color: #0cb8a8;
  transform: translateY(-50%) scale(1.1);
}

.field-input {
  width: 100%;
  height: 36px;
  padding: 0 15px;
  border: 1.5px solid #e8eef1;
  border-radius: 10px;
  font-size: 14px;
  color: #0a0f1a;
  background: #f9fbfc;
  transition: border-color 150ms, box-shadow 150ms, background 150ms, transform 150ms;
  outline: none;
  /* Override any Bootstrap form-control styles */
  -webkit-appearance: none;
  appearance: none;
}
.field-input.has-icon { padding-left: 42px; }
.field-input::placeholder { color: #b0b8cc; }
.field-input:focus {
  border-color: #0cb8a8;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(12,184,168,0.12);
  transform: translateY(-1px);
}

.input-wrapper .field-input { padding-right: 44px; }
.toggle-visibility {
  position: absolute;
  right: 11px; top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #a0aec0;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  transition: color 150ms, transform 150ms;
}
.toggle-visibility svg { width: 17px; height: 17px; }
.toggle-visibility:hover { color: #0cb8a8; transform: translateY(-50%) scale(1.12); }

/* Extras */
.form-extras {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}
.remember-me input[type="checkbox"] { display: none; }
.checkmark {
  width: 16px; height: 16px;
  border: 2px solid #0cb8a8;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  transition: background 150ms, transform 150ms;
  flex-shrink: 0;
}
.remember-me input[type="checkbox"]:checked + .checkmark {
  background: #0cb8a8;
  animation: checkPop 280ms ease;
}
.remember-me input[type="checkbox"]:checked + .checkmark::after {
  content: '';
  display: block;
  width: 4px; height: 8px;
  border: 2px solid #fff;
  border-top: none;
  border-left: none;
  transform: rotate(45deg) translateY(-1px);
}
@keyframes checkPop {
  0%   { transform: scale(0.7); }
  60%  { transform: scale(1.18); }
  100% { transform: scale(1); }
}
.remember-label { font-size: 13px; color: #4a5568; }
.forgot-link {
  font-size: 13px;
  color: #0cb8a8;
  text-decoration: none;
  font-weight: 600;
  transition: color 150ms;
}
.forgot-link:hover { color: #09998a; text-decoration: underline; }

/* Sign in button */
.sign-in-btn {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: #0cb8a8;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(12,184,168,0.35);
  transition: background 150ms, box-shadow 150ms, transform 100ms;
}
.sign-in-btn::after {
  content: '';
  position: absolute;
  top: 0; left: -75%;
  width: 50%; height: 100%;
  background: linear-gradient(120deg, transparent, rgba(255,255,255,0.4), transparent);
  transform: skewX(-20deg);
  transition: left 550ms ease;
}
.sign-in-btn:hover:not(:disabled)::after { left: 125%; }
.sign-in-btn:hover:not(:disabled) {
  background: #09998a;
  box-shadow: 0 6px 20px rgba(12,184,168,0.45);
  transform: translateY(-1px);
}
.sign-in-btn:active:not(:disabled) { transform: translateY(0); }
.sign-in-btn:disabled { cursor: wait; opacity: 0.75; }

/* Spinner */
.btn-spinner {
  width: 17px; height: 17px;
  border: 2.5px solid rgba(255,255,255,0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 650ms linear infinite;
  display: inline-block;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* Error */
.error-message {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 12px;
  padding: 10px 12px;
  background: #fff5f5;
  border: 1px solid #fed7d7;
  border-radius: 7px;
  color: #c53030;
  font-size: 12.5px;
  animation: fadeInUpCustom 250ms ease-out both;
}
.error-message svg { width: 15px; height: 15px; flex-shrink: 0; stroke: #c53030; }

/* Card footer */
.rp-footer {
  margin: 0.85rem 0 0;
  padding-top: 0.85rem;
  border-top: 1px solid #eef2f4;
  text-align: center;
  font-size: 9.5px;
  color: #c4cdd1;
  line-height: 1.7;
}
/* ── Tablet (md: 768–991px) ── */
@media (min-width: 768px) and (max-width: 991.98px) {
  .left-panel {
    flex: 0 0 50%;
    padding: 1.5rem 1.75rem;
  }
  .right-panel {
    flex: 0 0 50%;
    padding: 1.25rem 1.25rem;
  }
  .lp-title { font-size: 16px; letter-spacing: 2px; }
  .login-card { padding: 1.5rem 1.75rem 1.25rem; }
  .rp-title { font-size: 20px; }
}

/* ── Mobile (sm + xs: < 768px) — stack vertically ── */
@media (max-width: 767.98px) {
  .split-screen {
    flex-direction: column;
    min-height: 100vh;
    height: auto;
  }

  /* Left panel: compact banner strip */
  .left-panel {
    flex: none;
    padding: 1.5rem 1.25rem 1.25rem;
    min-height: auto;
    border-bottom: 1px solid rgba(12,184,168,0.18);
  }

  .lp-content {
    max-width: 100%;
  }

  .lp-title {
    font-size: 15px;
    letter-spacing: 2px;
    margin-bottom: 0.25rem;
  }

  .lp-subtitle {
    font-size: 11px;
    margin-bottom: 0.6rem;
  }

  .lp-divider {
    margin-bottom: 0;  /* no features shown on mobile, no gap needed */
  }

  /* Rings smaller on mobile so they don't bleed weirdly */
  .lp-ring-1 { width: 140px; height: 140px; top: -30px; right: -30px; }
  .lp-ring-2 { width: 80px; height: 80px; top: -10px; right: -10px; }

  /* Footer text inside left panel */
  .lp-footer { font-size: 8px; bottom: 0.5rem; }

  /* Right panel: full width, fills rest of page */
  .right-panel {
    flex: none;
    width: 100%;
    border-left: none;
    padding: 1.5rem 1rem 2rem;
    background: #f5f7fa;
    /* Let it grow naturally so card is never clipped */
    align-items: flex-start;
    padding-top: 1.75rem;
  }

  .login-card {
    border-radius: 16px;
    padding: 1.5rem 1.25rem 1.25rem;
    /* Disable card entrance animation delay on mobile so it appears immediately */
    animation-delay: 0s;
  }

  .rp-logo img { max-width: 130px; }

  .rp-title { font-size: 19px; }

  .field-input { height: 46px; font-size: 15px; }

  .sign-in-btn { height: 48px; font-size: 13px; }

  .form-extras { flex-wrap: wrap; gap: 8px; }
}

/* ── Small phones (xs: < 480px) ── */
@media (max-width: 479.98px) {
  .left-panel { padding: 1.25rem 1rem 1rem; }

  .lp-title { font-size: 13px; letter-spacing: 1.5px; }
  .lp-subtitle { font-size: 10px; }

  .right-panel { padding: 1.25rem 0.75rem 2rem; }

  .login-card {
    padding: 1.25rem 1rem 1rem;
    border-radius: 14px;
  }

  .rp-logo img { max-width: 110px; }

  .rp-title { font-size: 17px; }
  .rp-subtitle { font-size: 11.5px; }

  .remember-label { font-size: 12px; }
  .forgot-link { font-size: 12px; }

  .sign-in-btn { height: 46px; font-size: 12.5px; letter-spacing: 1px; }
}
</style>